// DEPRECATED: This function is no longer used - paired products now use renderContents()
// Keeping commented out for reference in case rollback is needed
// async function fetchAndReplaceHtml(t) {
//     let e = window.Shopify.routes.root + "cart?section_id=main-cart-items";
//     try {
//         let a = await fetch(e),
//             i = await a.text(),
//             r = new DOMParser().parseFromString(i, "text/html").getElementById("main-cart-items").innerHTML;
//         (document.getElementById(t).innerHTML = r), document.getElementsByTagName("cart-drawer")[0].open();
//     } catch (s) {
//         console.error("Error fetching and replacing HTML:", s);
//     }
// }
async function updateCartSubtotal() {
    let t = window.Shopify.routes.root + "cart.js";
    try {
        let e = await fetch(t),
            a = await e.json(),
            i = a.total_price / 100,
            r = document.getElementsByClassName("totals__total-value");
        if (r.length > 0) for (let s = 0; s < r.length; s++) r[s].textContent = `$${i.toFixed(2)}`;
        else console.error("Cart subtotal element not found.");
    } catch (o) {
        console.error("Error updating cart subtotal:", o);
    }
}
/*function owlInit(){$(".tab_product_slider").owlCarousel({loop:false,margin:20,dots:true,nav:true,responsive:{0:{items:1.2,margin:10,dot:true},481:{items:1,margin:10,dot:true},768:{items:2.3,margin:10,dot:true},992:{items:3,margin:15,dot:true},1200:{items:3},1301:{items:4}},onInitialized: updateProgress,onChanged: updateProgress})}*/ function productImageOwlInit() {
    $(".tab_image_mobile_Slider").owlCarousel({ loop: !1, dots: !1, nav: !1, responsive: { 0: { items: 1, margin: 10 }, 575: { items: 2, margin: 15 } } });
}
/*function blogSliderOwlInt(){$(".blog_slider").owlCarousel({loop:!1,margin:20,nav:!0,dots:!1,responsive:{0:{items:1,margin:10,nav:!1},576:{items:2,margin:10,nav:!1},767:{items:2,margin:15,nav:!1},1301:{items:2}}})}*/ $(document).ready(
    function () {
        productImageOwlInit(),
            $(".video_slider").owlCarousel({
                loop: !1,
                margin: 20,
                nav: !1,
                responsive: {
                    0: { items: 1, margin: 10, nav: !1, dots: !1 },
                    480: { items: 2, margin: 10, nav: !1, dots: !1, autoplay: !0, autoplayTimeout: 3e3, autoplaySpeed: 2e3 },
                    575: { items: 3, margin: 10, nav: !1, dots: !1 },
                    991: { items: 3, margin: 15, nav: !1, dots: !1 },
                    1024: { items: 3 },
                },
            }),
            $(".testimonial").owlCarousel({
                loop: !1,
                margin: 20,
                dots: !1,
                nav: !0,
                responsive: { 0: { items: 1, margin: 10, nav: !1 }, 576: { items: 2, margin: 10, nav: !1 }, 991: { items: 2, margin: 15, nav: !1, autoplay: !0, autoplayTimeout: 3e3, autoplaySpeed: 2e3 }, 1300: { items: 3 } },
            }),
            $(".product_ingredient").owlCarousel({ loop: false, center: true, margin: 30, nav: !0, dots: !1, responsive: { 0: { items: 1, margin: 6 }, 576: { items: 2, margin: 10 }, 767: { items: 2, margin: 15 }, 1e3: { items: 2 } } }),
            $(".product-form__input--swatch").owlCarousel({ stagePadding: 50, loop: !1, center: !0, margin: 30, nav: !1, dots: !1, responsive: { 0: { items: 3 }, 575: { items: 3 }, 767: { items: 3 }, 1e3: { items: 5 } } }),
            $(".video_slider").on("click", ".playbtn", function () {
                let t = $(this),
                    e = t.closest(".video-poster-wrapper").find("video"),
                    a = t.siblings(".pausebtn");
                $(".videoplay").each(function () {
                    this.pause(), $(this).siblings(".playbtn").show(), $(this).siblings(".pausebtn").hide();
                }),
                    e[0].play(),
                    t.hide(),
                    a.show();
            }),
            $(".video_slider").on("click", ".pausebtn", function () {
                let t = $(this),
                    e = t.closest(".video-poster-wrapper").find("video"),
                    a = t.siblings(".playbtn");
                e[0].pause(), t.hide(), a.show();
            }),
            $(".product-form__quantity, .btn_main_wrapper").wrapAll('<div class="quantity-buy-btn-wrapper"></div>'),
            $(document).on("change", '.product-form__input input[type="radio"]', function () {
                let t = $(this).data("price"),
                    e = $(this).data("varientid");
                setTimeout(function () {
                    let e = $(".prodFormSubmitCustom span").text();
                    $(".prodFormSubmitCustom span").text(`${t} - ${e}`);
                }, 1e3),
                    $(".bundle-outer-wrapp .bundle-prod-cont #main-price").text(t),
                    $(".bundle-outer-wrapp .bundle-prod-cont .both_addtocart").attr("data-mainproduct", e);
                let a = $("#varient-opt-1");
                a.find("option").each(function () {
                    $(this).data("varientid") == e ? $(this).prop("selected", !0) : $(this).prop("selected", !1);
                }),
                    a.trigger("change"),
                    $(".changePriceStickyBar").text(t);
            }),
            $(".tab_product_image_slider").owlCarousel({ loop: !1, margin: 10, nav: !1, dots: !1, responsive: { 0: { items: 2 }, 575: { items: 2 }, 768: { items: 3 }, 1200: { items: 4 }, 1301: { items: 6 } } }),
            $(".blog_tab_slider").owlCarousel({
                loop: !1,
                margin: 10,
                nav: !1,
                dots: !1,
                responsive: { 0: { items: 2, margin: 15 }, 575: { items: 2, margin: 15 }, 768: { items: 3, margin: 15 }, 1200: { items: 4, margin: 15 }, 1301: { items: 6 } },
            }),
            $(".ingedient_slider").owlCarousel({ loop: !1, margin: 10, dots: !1, nav: !1, responsive: { 0: { items: 2 }, 481: { items: 2 }, 575: { items: 3 } } }),
            $(".tab_slider_coll").owlCarousel({ loop: !1, dots: !1, margin: 10, nav: !1, responsive: { 0: { items: 2 }, 575: { items: 2 }, 768: { items: 3 }, 1200: { items: 4 }, 1301: { items: 6 } } }),
            // $(".menu_slider").owlCarousel({ loop: !1, dots: !1, margin: 10, nav: !1, responsive: { 0: { items: 2 }, 575: { items: 2 }, 768: { items: 2 } } }),

            // add to cart - Paired Product Handler
            // Simplified to work with UpCart - let the active cart system handle drawer
            $(".both_addtocart").on("click", function (e) {
                e.preventDefault(); // Prevent default link behavior
                e.stopPropagation(); // Stop event from bubbling to parent anchor tag

                let variantId = $(this).attr("data-bundleproductid");
                let price = $(this).attr("data-mainProductPrice");
                let button = $(this);

                console.log('[PAIRED PRODUCT] Adding variant to cart:', variantId);

                button.text("Please Wait.....").attr("disabled", true);

                // Simple cart add - let UpCart or native cart handle the drawer automatically
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        items: [{
                            id: variantId,
                            quantity: 1
                        }]
                    },
                    dataType: "json",
                    success: function(response) {
                        console.log('[PAIRED PRODUCT] Cart add success:', response);

                        // Update cart count
                        var cartCount = $(".cart_count");
                        var newCount = (parseInt(cartCount.text().replace(/[()]/g, ''), 10) || 0) + 1;

                        if (jQuery(".cart-count-bubble").length == 0) {
                            cartCount.html(`(${newCount})`);
                        } else {
                            cartCount.text(newCount);
                        }

                        // Trigger Shopify cart update event (UpCart listens for this)
                        document.dispatchEvent(new CustomEvent('cart:updated', {
                            detail: { cart: response }
                        }));

                        // Also fire cart change event
                        fetch('/cart.js')
                            .then(res => res.json())
                            .then(cart => {
                                document.documentElement.dispatchEvent(
                                    new CustomEvent('cart:change', {
                                        detail: { cart: cart }
                                    })
                                );
                            });

                        // Reset button
                        button.text(`ADD TO CART ${price}`).attr("disabled", false);

                        console.log('[PAIRED PRODUCT] Cart system should handle drawer automatically');
                    },
                    error: function(xhr) {
                        console.error('[PAIRED PRODUCT] Cart add error:', xhr);
                        alert("Failed to add product to cart. Please try again.");
                        button.text(`ADD TO CART ${price}`).attr("disabled", false);
                    }
                });
            }),
            $(".bundle_product_select").on("click", function () {
                let t = $(this),
                    e,
                    a = `items[0][id]=${t.attr("data-bundleproductid")}&items[0][quantity]=1`;
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: a,
                    dataType: "json",
                    beforeSend: function () {
                        t.text("Please Wait....."), t.attr("disabled", !0);
                    },
                    success: function (e) {
                        var a = $(".cart-link__bubble-num"),
                            i = (parseInt(a.text(), 10) || 0) + 1;
                        0 == $(".cart-count-bubble").length
                            ? $("#cart-icon-bubble").append("<div class='cart-count-bubble'><span aria-hidden='true' class='cart-link__bubble-num'>" + i + "</span><span class='visually-hidden'>" + i + "</span></div>")
                            : a.text(i),
                            fetchAndReplaceHtml("CartDrawer-CartItems").then(function () {
                                $(".cart-item__totals").length > 0 && $(".cart-item__totals").removeClass("medium-hide large-up-hide"), $("tr td:last-child").hide();
                            }),
                            updateCartSubtotal(),
                            $("cart-drawer").removeClass("is-empty"),
                            $(".drawer__inner-empty").hide(),
                            $("cart-drawer-items").removeClass("is-empty"),
                            $("#CartDrawer-Checkout").attr("disabled", !1),
                            t.text("Shop Now"),
                            t.attr("disabled", !1);
                    },
                    error: function (e) {
                        console.error(e), alert("Failed to add products to the cart. Please try again."), t.text("Shop Now"), t.attr("disabled", !1);
                    },
                });
            });
        document
            .querySelector(".header__inline-menu")
            .querySelectorAll("details")
            .forEach((t) => {
                t.addEventListener("mouseover", () => {
                    t.setAttribute("open", !0),
                        document.querySelector(".section-header").classList.add("hovered-class"),
                        t.querySelector("ul").addEventListener("mouseleave", () => {
                            t.removeAttribute("open"), document.querySelector(".section-header").classList.remove("hovered-class");
                        }),
                        t.addEventListener("mouseleave", () => {
                            t.removeAttribute("open"), document.querySelector(".section-header").classList.remove("hovered-class");
                        });
                });
            }),
            $(window).on("scroll", function () {
                $(this).scrollTop() > 10 ? $(".section-header").addClass("stick-header-wrapp") : $(".section-header").removeClass("stick-header-wrapp");
            }),
            $(".icon-hamburger").click(function () {
                $("body").addClass("menu-class-triggred"),
                    $(".icon-close").click(function () {
                        $("body").removeClass("menu-class-triggred");
                    });
            }),
            $(".price-item.price-item--regular, .price-item.price-item--sale.price-item--last").html(function () {
                var t = $(this).text().trim().split(" "),
                    e = t.shift();
                return (t.length > 0 ? "<span class='hiddenText'>" + e + "</span> " : e) + t.join(" ");
            });
    }
);


/** ----------product media right left click image slide------------- */
jQuery(document).ready(function($) {
    function updateCursorStyles() {
        // Since carousel is infinite, arrows are always clickable
        $('.prod_left svg, .prod_right svg').css('cursor', 'pointer');
    }

    // Helper: get the list of slide <li> elements for the current carousel
    function getListFor($li) {
        // prefer nearest list-like container; adjust selectors if your markup is different
        var $list = $li.closest('ul, ol');
        if ($list.length === 0) {
            // fallback: maybe li's parent is not ul/ol — use direct parent
            $list = $li.parent();
        }
        return $list.children('li');
    }

    updateCursorStyles();

    // Right arrow: go to next (wrap to first)
    $('.prod_right svg').on('click', function(e) {
        e.preventDefault();

        var $currentButton = $('button[aria-current="true"]');
        if ($currentButton.length === 0) return; // nothing active

        var $currentLi = $currentButton.closest('li');
        var $allLis = getListFor($currentLi);
        var len = $allLis.length;
        if (len === 0) return;

        var idx = $allLis.index($currentLi);
        var nextIdx = (idx + 1) % len; // wraps to 0 when at last
        var $targetLi = $allLis.eq(nextIdx);
        var $targetButton = $targetLi.find('button');

        // Update aria-current consistently
        $allLis.find('button').attr('aria-current', 'false');
        $targetButton.attr('aria-current', 'true');

        // Trigger click handler on target button if your carousel uses clicks to change slides
        $targetButton.trigger('click');

        updateCursorStyles();
    });

    // Left arrow: go to previous (wrap to last)
    $('.prod_left svg').on('click', function(e) {
        e.preventDefault();

        var $currentButton = $('button[aria-current="true"]');
        if ($currentButton.length === 0) return; // nothing active

        var $currentLi = $currentButton.closest('li');
        var $allLis = getListFor($currentLi);
        var len = $allLis.length;
        if (len === 0) return;

        var idx = $allLis.index($currentLi);
        var prevIdx = (idx - 1 + len) % len; // wraps to len-1 when at first
        var $targetLi = $allLis.eq(prevIdx);
        var $targetButton = $targetLi.find('button');

        $allLis.find('button').attr('aria-current', 'false');
        $targetButton.attr('aria-current', 'true');
        $targetButton.trigger('click');

        updateCursorStyles();
    });
});
/** ----------product media right left click image slide------------- */




var btn = $('#button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});

// jQuery('.feature_image_write_wrapper, .feature_content_wrapper').wrapAll('<div class="article-wrapper-main-box"></div>');



jQuery(document).ready(function(){
  setTimeout(function(){
    // Target all cart count spans
    jQuery('.cart_count').each(function(){
      let count = jQuery(this).text().replace(/[()]/g, '').trim(); // remove existing ()
      if(count !== ''){
        jQuery(this).text('(' + count + ')');
      }
    });
  }, 1000); // 1 second delay
});

/**
 * FAILSAFE: Cart Drawer Scroll Lock Cleanup
 *
 * This monitors the cart drawer state and ensures the body scroll lock
 * is properly removed when the drawer closes. This acts as a defensive
 * safeguard against edge cases where the close() method might not fire
 * properly (especially on mobile devices).
 *
 * Added: 2025-11-10 - Fix for mobile scroll lock issue with paired products
 */
(function() {
    'use strict';

    console.log('[SCROLL LOCK FAILSAFE] Initializing cart drawer monitor');

    // Wait for DOM to be ready
    function initScrollLockFailsafe() {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
            console.log('[SCROLL LOCK FAILSAFE] Native cart drawer found');

            // Monitor cart drawer for class changes (active/inactive state)
            const drawerObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.attributeName === 'class') {
                        const isActive = cartDrawer.classList.contains('active');
                        console.log('[SCROLL LOCK FAILSAFE] Drawer state changed. Active:', isActive);

                        if (!isActive) {
                            // Small delay to allow animations to complete
                            setTimeout(function() {
                                if (document.body.classList.contains('overflow-hidden')) {
                                    console.warn('[SCROLL LOCK FAILSAFE] Removing orphaned overflow-hidden class');
                                    document.body.classList.remove('overflow-hidden');
                                }
                            }, 300);
                        }
                    }
                });
            });

            drawerObserver.observe(cartDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        } else {
            console.warn('[SCROLL LOCK FAILSAFE] Native cart drawer not found - UpCart may be active');
        }

        // AGGRESSIVE: Monitor body classes directly as primary failsafe
        // This works regardless of which cart system is active
        const bodyObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    const hasOverflow = document.body.classList.contains('overflow-hidden');

                    if (hasOverflow) {
                        // Check if ANY drawer is visible
                        const anyDrawerVisible = isAnyDrawerVisible();

                        if (!anyDrawerVisible) {
                            // No visible drawer, but body is locked - FIX IT
                            setTimeout(function() {
                                if (document.body.classList.contains('overflow-hidden') && !isAnyDrawerVisible()) {
                                    console.warn('[SCROLL LOCK FAILSAFE] Body locked with no visible drawer - FORCE UNLOCKING');
                                    document.body.classList.remove('overflow-hidden');
                                }
                            }, 500);
                        }
                    }
                }
            });
        });

        bodyObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });

        // Also check on touch/scroll attempt
        document.addEventListener('touchstart', function() {
            if (document.body.classList.contains('overflow-hidden') && !isAnyDrawerVisible()) {
                console.warn('[SCROLL LOCK FAILSAFE] Touch detected with scroll lock but no drawer - unlocking');
                document.body.classList.remove('overflow-hidden');
            }
        }, { passive: true });

        console.log('[SCROLL LOCK FAILSAFE] Monitors installed successfully');
    }

    // Helper function to check if ANY cart drawer (native or UpCart) is visible
    function isAnyDrawerVisible() {
        // Check native drawer
        const nativeDrawer = document.querySelector('cart-drawer');
        if (nativeDrawer && nativeDrawer.classList.contains('active')) {
            return true;
        }

        // Check for UpCart drawers (common selectors)
        const upcartSelectors = [
            '[id*="upcart"]',
            '[class*="upcart"]',
            '[data-drawer-type="cart"]',
            '.drawer.is-open',
            '.cart-drawer.active'
        ];

        for (let selector of upcartSelectors) {
            const element = document.querySelector(selector);
            if (element && element.offsetHeight > 0 && getComputedStyle(element).display !== 'none') {
                return true;
            }
        }

        return false;
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollLockFailsafe);
    } else {
        initScrollLockFailsafe();
    }
})();
